module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-douwe-egberts-00.2@2x.70406ef8.jpg";